module.exports = __webpack_public_path__ + "c5bca7c58bc548271b6dc4629ca15ac6.jpg";